import { config } from '@/config'

export default {
	items(state, getters) {
		return getters["cart/items"]
	},
	brands(state) {
		return state.brands;
	},
}